"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ModelCompositorCategorys_1 = __importDefault(require("./ModelCompositorCategorys"));
class ModelCompositorData {
    constructor(data) {
        this.proposalId = -1;
        this.proposalId = data.proposalId || -1;
        if (data.rates) {
            this.rates = new ModelCompositorCategorys_1.default(data.rates).getAllCategorys();
        }
        else {
            this.rates = new Array();
        }
    }
    getProposalId() {
        return this.proposalId;
    }
    getAllCategories() {
        return new ModelCompositorCategorys_1.default(this.rates);
    }
}
exports.default = ModelCompositorData;
